import './index.scss'; // To move back to profile.js

import React from 'react';
import { useSelector } from 'react-redux';
import { Tab, TabList, TabPanel } from 'react-tabs';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import Tabs from '@/src/components/common/Elements/Tabs/Tabs';
import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

import Profile from './profile';
import { ScopeTab } from './Tabs/ScopeTab';

export const ProfileSection = () => {
  const project = useSelector((store: RootState) => store.project?.Selected);

  if (!project) {
    return <SectionLoader />;
  }

  return (
    <div>
      <div className="card-header">
        <h4 className="settingsMainTitle"> Company Profile</h4>
      </div>
      <div className="row company-details-container">
        <div className="col-lg-12 pd0">
          <div className="card form-card">
            <div className="card-body">
              <div id="general" className="memberFormsContainer mt0">
                <div className="memberFormContainer mt0">
                  <Tabs className={cn('detailsTab, tw-mt-[-20px]')} forceRenderTabPanel={true}>
                    <div className="tab-list-container tw-relative tw-flex tw-justify-between tw-items-center">
                      <TabList className={'tw-w-full'}>
                        <Tab className={'tw-text-[18px]'}>Information</Tab>
                        <Tab className={'tw-text-[18px] tw-ml-[15px]'}>Scope</Tab>
                      </TabList>
                    </div>

                    <TabPanel className={''}>
                      <Profile />
                    </TabPanel>

                    <TabPanel className={''}>
                      <ScopeTab />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
